import React, { useEffect, useState } from 'react';
import { Storage, translate } from 'react-jhipster';
import { Grid, Divider } from '@mui/material';
import moment from 'moment';
import { StyledTable, StyledTableCell } from 'app/entities/quotation/bought/quotation-bought.style';
import axios from 'axios';
import {countryList} from 'app/entities/bank/country';
import {forceLogoAlignment, isLocalCommodity} from 'app/shared/util/quotation-utils';
import {formatCurrency} from 'app/shared/util/currency-utils';
import './quotation-print.scss';
import { formatDateWithLTR } from 'app/shared/util/date-utils';

export const QuotationPrint = ({ quotationEntity, bankStaffAccount, hidden = true }) => {
  const [itemDescriptionInArabic, setItemDescriptionInArabic] = useState('');
  const [transactionFeeData, setTransactionFeeData] = useState('');
  const [customerNationalityData, setCustomerNationalityData] = useState('');

  const createdDate = moment(quotationEntity?.createdDate).format('yyyy/MM/DD');
  const todayDate = moment().format('yyyy/MM/DD');
  const hidetotalAmount = true;
  const currencyNameData = quotationEntity?.currencyIndex?.name || '';
  const selectedNationality = countryList?.find(c => c?.Desc_en === customerNationalityData);

  useEffect(() => {
    if (quotationEntity?.transactionFee !== null && quotationEntity?.transactionFee !== undefined) {
      setTransactionFeeData(quotationEntity?.transactionFee?.toLocaleString() || '');
    } else {
      const fee = quotationEntity?.fee;
      const commission = quotationEntity?.commission;
      const transactionFee = fee + commission;
      setTransactionFeeData(transactionFee.toLocaleString());
    }
    setCustomerNationalityData(quotationEntity?.customer?.nationality || '');
  }, []);

  useEffect(() => {
    if (quotationEntity?.description && Storage.session.get('locale') === 'ar-ly') {
      const data = {
        q: quotationEntity?.description || '',
        source: 'en',
        target: 'ar',
        api_key: '',
      };
      axios.post(`https://translate.argosopentech.com/translate`, data).then(response => {
        setItemDescriptionInArabic(response?.data?.translatedText);
      });
    }
  }, [quotationEntity?.description]);

  const getQuotationDisclaimer = () => {
    if (isLocalCommodity(quotationEntity?.commodity) && quotationEntity?.bank?.quotationValidityDays !== null) {
      const validityEndDate = quotationEntity?.validUntil
        ? formatDateWithLTR(quotationEntity?.validUntil)
        : formatDateWithLTR(moment(createdDate).add(quotationEntity?.bank?.quotationValidityDays - 1, 'days'));

      return translate('comexApp.quotation.transactionForms.quotationPrintDisclaimerWithDate', {
        validityEndDate,
      });
    }

    if (createdDate !== todayDate) {
      return translate('comexApp.quotation.transactionForms.quotationPrintDisclaimerWithDate', {
        validityEndDate: formatDateWithLTR(createdDate),
      });
    }
    return translate('comexApp.quotation.transactionForms.quotationPrintDisclaimer');
  };

  useEffect(() => {
    forceLogoAlignment('divToPrint');
  }, [Storage.session.get('locale')]);

  return (
    <div
      hidden={hidden}
      className="App container mt-5"
      style={{
        height: '1100px',
        position: 'relative',
        maxWidth: '794px', // A4 width in pixels
        width: '100%',
        overflow: 'hidden',
        margin: '0 auto',
        padding: '0 20px',
        boxSizing: 'border-box',
      }}
    >
      <div id="divToPrint">
        <div id="headerPrint" className="header-print">
          <div className="logo-header">
            <img src={`${window.location.origin}/content/images/img.png`} className="alshmokh-logo" />
          </div>
          <br />
          <br />
          <div>
            <strong>
              <h4 style={{ margin: 0, fontSize: '2.125rem', fontWeight: 400, lineHeight: 1.235 }}>
                {translate('comexApp.quotation.print.quotation')}
              </h4>
            </strong>
          </div>
        </div>

        <Divider sx={{ borderBottomWidth: 3, marginLeft: '48px', marginRight: '48px', borderColor: '#01579b' }} />

        <div id="quotationTablePrint">
          <div>
            <p className="text-1rem">
              <strong>{translate('comexApp.quotation.print.information')}</strong>
            </p>
            <p className="text-desc text-1rem">
              {translate('comexApp.quotation.quotationNo')} : {quotationEntity?.id || ''}
              <span hidden={quotationEntity?.lastModifiedDate === null}>{translate('comexApp.quotation.print.revised')}</span>
            </p>
            <p className="text-desc text-1rem">
              {translate('comexApp.quotation.date')} : {moment(quotationEntity?.createdDate).local().format('yyyy/MM/DD HH:mm:ss') || ''}
            </p>
          </div>
        </div>

        <div id="informationPrint">
          <Grid container spacing={2} className="grid-container">
            <Grid item xs={8} className="grid-item-left">
              <p className="info-title">
                <strong>{translate('comexApp.quotation.transactionForms.table1.to')}</strong>
              </p>
              <p className="text-desc text-1rem">{quotationEntity?.bank?.name || ''}</p>
              <p className="text-desc text-1rem">{quotationEntity?.branch?.name || ''}</p>
              <p className="text-desc text-1rem">
                {bankStaffAccount.firstName || ''} {bankStaffAccount.lastName || ''}
              </p>
            </Grid>
            <Grid item xs={4} className="grid-item-right">
              <p className="info-title">
                <strong>{translate('comexApp.quotation.customer')}</strong>
              </p>
              <p className="text-desc text-1rem">
                {quotationEntity?.commodity?.ownership === 'Local' && quotationEntity?.customer?.nameArabic
                  ? quotationEntity?.customer?.nameArabic
                  : quotationEntity?.customer?.name || ''}
              </p>
              <p className="text-desc text-1rem">
                {Storage.session.get('locale') === 'en' ? quotationEntity?.customer?.nationality : selectedNationality?.Desc_ar}
              </p>
              <p className="text-desc">{quotationEntity?.customer?.ic || ''}</p>
              <p className="text-desc text-1rem">{quotationEntity?.customer?.tel || ''}</p>
              <p className="text-desc text-1rem">{quotationEntity?.customer?.email || ''}</p>
            </Grid>
          </Grid>

          <div className="table-container">
            <table className="quotation-table">
              <thead>
                <tr>
                  <td className="table-header-cell">{translate('comexApp.quotation.description')}</td>
                  <td className="table-header-cell">{translate('comexApp.quotation.price')}</td>
                  <td className="table-header-cell">{translate('comexApp.quotation.quantity')}</td>
                  <td className="table-header-cell">{translate('comexApp.quotation.amount')}</td>
                </tr>
              </thead>
              <tbody>
              <tr>
                <td className="table-body-cell">
                  {Storage.session.get('locale') === 'en' ? quotationEntity?.description : itemDescriptionInArabic || quotationEntity?.description}
                </td>
                <td className="table-body-cell">
                  {formatCurrency(quotationEntity?.commodityUnitPrice?.toLocaleString(), currencyNameData)}
                </td>
                <td className="table-body-cell">
                  {formatCurrency(quotationEntity?.commodityQuantity?.toLocaleString(), quotationEntity?.commodityUnit)}
                </td>
                <td className="table-body-cell">
                  {formatCurrency(quotationEntity?.amount?.toLocaleString(), currencyNameData)}
                </td>
              </tr>

              <tr hidden={true}>
                <td className="table-empty-cell" colSpan={2}></td>
                <td className="table-body-cell">
                  <strong>{translate('comexApp.quotation.transactionFee')}</strong>
                </td>
                <td className="table-body-cell">
                  {formatCurrency(transactionFeeData, quotationEntity?.feeCurrencyIndex)}
                </td>
              </tr>

              <tr hidden={hidetotalAmount}>
                <td className="table-empty-cell" colSpan={2}></td>
                <td className="table-body-cell">
                  <strong>{translate('comexApp.quotation.totalAmount')}</strong>
                </td>
                <td className="table-body-cell">
                  {formatCurrency(quotationEntity?.totalAmount?.toLocaleString(), currencyNameData)}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="signature-container">
          <p className="signature-text">
            {translate('comexApp.quotation.print.customerSignature')}:&nbsp;
            <span className="signature-line"></span>
          </p>
        </div>

        <Divider sx={{ borderBottomWidth: 3, marginLeft: '48px', marginRight: '48px', borderColor: '#01579b' }} />

        <div className="disclaimer-container">
          <p className="disclaimer-text">{getQuotationDisclaimer()}</p>
        </div>

        <div className="footer-container">
          <img src="../../../../../content/images/footer-transaction-forms.jpg" className="imageFooter" />
        </div>

        <div id="informationPrint" style={{ margin: '24px 48px 24px 48px' }}>
          <Grid container>
            <Grid item xs={4} style={{ lineHeight: 1, display: 'inline-flex', justifyContent: 'center' }}>
              <div>{/* <Typography variant='body1' ><strong>Bank</strong></Typography> */}</div>
            </Grid>
            <Grid item xs={4} style={{ lineHeight: 1, display: 'inline-flex', justifyContent: 'center' }}>
              <div>{/* <Typography variant='body1' ><strong>Alsmokh</strong></Typography> */}</div>
            </Grid>
            <Grid item xs={4} style={{ lineHeight: 1, display: 'inline-flex', justifyContent: 'center' }}>
              <div>{/* <Typography variant='body1' ><strong>Created By</strong></Typography> */}</div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};
